import { render } from "./FavoriteVouchersPage.vue?vue&type=template&id=89004300&scoped=true"
import script from "./FavoriteVouchersPage.vue?vue&type=script&lang=js"
export * from "./FavoriteVouchersPage.vue?vue&type=script&lang=js"

import "./FavoriteVouchersPage.vue?vue&type=style&index=0&id=89004300&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89004300"]])

export default __exports__